module.exports = __webpack_public_path__ + "e9e5951f6e178cf6e973b4151376630c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/Thiet_Ke_Bao_Bi.svg
// module id = ./assets/images/advisory/Thiet_Ke_Bao_Bi.svg
// module chunks = 0